export default [
  {
    name: "CourseInfo"
  }
];
